import { ProCard } from '@ant-design/pro-components'
import { localQueryEntityOptions } from '@app/icare/client/db/client/localQueryOneOptions'
import { EntityDeleteButton } from '@app/icare/components/entity/EntityDeleteButton'
import { EntityDeletedBanner } from '@app/icare/components/entity/EntityDeletedBanner'
import { ClinicId } from '@app/icare/entities/clinic/schema/Clinic'
import { useEntityDeletion } from '@app/icare/hooks/useEntityDeletion'
import { t } from '@lingui/core/macro'
import { zodParams } from '@pkg/db/utils'
import { useRouterTabs } from '@pkg/ui/hooks'
import { usePageContainerOverride } from '@pkg/ui/layout/PageContainer'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { Tabs } from 'antd'
import { z } from 'zod'

export const Route = createFileRoute('/_app/kliniken/$id')({
  component: RouteComponent,
  params: zodParams(z.object({ id: ClinicId.ref })),
  validateSearch: zodValidator(
    z.object({
      tab: z.enum(['general', 'contact_persons', 'stations']).optional(),
    }),
  ),
  loader: () => ({
    breadcrumb: {
      label: t`Kliniken`,
      to: '/kliniken',
    },
  }),
})

function RouteComponent() {
  const params = Route.useParams()

  const { data } = useQuery(localQueryEntityOptions(params.id))
  const deletion = useEntityDeletion({ data, entityType: 'clinics' })
  const title = data?.name || 'Neuer Eintrag'

  const tabs = useRouterTabs()

  usePageContainerOverride(
    {
      header: {
        title,
        extra: <EntityDeleteButton {...deletion} />,
        footer: (
          <Tabs
            {...tabs}
            items={[
              {
                key: `/kliniken/${params.id}`,
                label: 'Allgemein',
              },
              {
                key: `/kliniken/${params.id}/contact-persons`,
                label: 'Ansprechpartner',
              },
              {
                key: `/kliniken/${params.id}/stations`,
                label: 'Stationen',
              },
            ]}
          />
        ),
      },
    },
    [title, tabs.activeKey, deletion.isDeleted, deletion.isPending],
  )

  if (!data) {
    return <ProCard loading />
  }

  return (
    <>
      <EntityDeletedBanner {...deletion} />
      <Outlet />
    </>
  )
}
